module.exports = __webpack_public_path__ + "static/media/portal-logo.3fba30b4.svg";